import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import jaLang from './ja/ja'
import VueCookie from 'vue-cookies'
import { localize } from '@vee-validate/i18n'

const app = createApp({})

const lang = {
  ja: jaLang,
}

localize({
  // en,
  ja: { ...jaLang.validation },
})

app.use(createI18n)

const dateTimeFormats = {
  ja: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    short_numeric: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
    time: {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    },
    short_time: {
      hour: '2-digit',
      minute: '2-digit',
    },
    short_date_time: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    },
  },
}

const numberFormats = {
  ja: {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol',
    },
  },
}

const i18n = createI18n({
  dateTimeFormats,
  numberFormats,
  locale: VueCookie.get('locale') || 'ja', // set locale
  messages: lang,
  fallbackLocale: 'ja',
})

export default i18n
